import { render, staticRenderFns } from "./CardRequestDeposit.vue?vue&type=template&id=2bfab3b6"
import script from "./CardRequestDeposit.js?vue&type=script&lang=js&external"
export * from "./CardRequestDeposit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports